import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import NewsQuickList from "./components/NewsQuickList";
import WorkShowcase from "./components/WorkShowcase";
import SiteIntro from "./components/SiteIntro";
import { newsList, newsCategories } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import { profile } from "@/mocks/profile";

const HOME_TITLE = "白石茉莉奈最新资讯与作品介绍 - 明星动态平台";
const HOME_DESCRIPTION =
  "白石茉莉奈明星资讯平台，提供她的最新动态、个人资料、影视作品和相关资讯，助您全面了解白石茉莉奈的魅力与艺术成就。";
const HOME_KEYWORDS =
  "白石茉莉奈,白石茉莉奈作品,白石茉莉奈资讯,明星动态,影视明星,个人资料,白石茉莉奈介绍";

export default function Home() {
  const sortedNews = [...newsList].sort((a, b) => b.date.localeCompare(a.date));
  const heroItems = sortedNews.slice(0, 4);
  const quickList = sortedNews.slice(0, 10);
  const featuredWorks = [...worksList]
    .sort((a, b) => b.year - a.year || b.rating - a.rating)
    .slice(0, 6);

  return (
    <SiteLayout
      title={HOME_TITLE}
      description={HOME_DESCRIPTION}
      keywords={HOME_KEYWORDS}
      scrollToTop
    >
      <HeroCarousel items={heroItems} />

      <div className="px-4 md:px-8 py-12 md:py-16 space-y-14 md:space-y-20">
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-2">
            <SectionHeading
              title="资讯快览"
              subtitle="按时间倒序展示最近动态"
              action={
                <Link
                  to="/news"
                  className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-body whitespace-nowrap"
                >
                  更多资讯
                  <i className="ri-arrow-right-line"></i>
                </Link>
              }
            />
            <NewsQuickList items={quickList} />
          </div>

          <aside className="space-y-6">
            <div className="bg-foreground-950 rounded-lg p-6 text-background-50">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full overflow-hidden shrink-0 border-2 border-accent-500">
                  <img
                    src={profile.avatar}
                    alt={`${profile.name} 代表照`}
                    title={`${profile.name} - 个人资料`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-lg">{profile.name}</h3>
                  <p className="text-xs text-foreground-300 font-body mt-1">
                    {profile.profession}
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed mt-4 font-body line-clamp-3">
                {profile.bio[0]}
              </p>
              <Link
                to="/profile"
                className="inline-flex items-center gap-1.5 mt-5 px-4 py-2 rounded-md bg-accent-500 text-foreground-950 text-sm font-body hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                查看个人资料
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="bg-background-50 rounded-lg border border-background-200 p-6">
              <h3 className="font-heading text-base text-foreground-950 mb-4">
                热门标签
              </h3>
              <div className="flex flex-wrap gap-2">
                {newsCategories.map((tag) => (
                  <Link
                    key={tag}
                    to={`/news?tag=${encodeURIComponent(tag)}`}
                    className="text-xs font-body px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 hover:bg-secondary-500 hover:text-background-50 transition-colors"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </section>

        <WorkShowcase items={featuredWorks} />

        <SiteIntro />
      </div>
    </SiteLayout>
  );
}